window.bz_chart_module = angular.module('bzChartModule', [])
